<!-- 发票管理 -->
<template>
  <div>
    <div class="container">
      <e-search
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <el-row>
        <div class="crumbs">
          <!--          <div style="margin-bottom: 20px">-->
          <!--            <d-button-->
          <!--              btnType="default"-->
          <!--              btnTxt="导出售后订单"-->
          <!--              v-on:debounceclick="handleImportOrder"-->
          <!--            ></d-button>-->
          <!--          </div>-->
        </div>
      </el-row>
      <div>
        <table-list
          :index-show="indexShow"
          :loading="loading"
          :table-data="tableData"
          :table-label="tableLabel"
          @handleButton="handleButton"
          @handleSortChange="handleSortChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <!-- eslint-disable-next-line -->
          <template v-slot:electronicInvoiceFlagSlot="slot">
            <div>
              {{
                slot.scope.row.electronicInvoiceFlag === 1
                  ? '电子发票'
                  : '纸质发票'
              }}
            </div>
          </template>
          <template v-slot:operate="slot">
            <div class="line">
              <div
                @click="handleRecive(slot.scope.row)"
                class="btn-box"
                v-if="slot.scope.row.invoiceStatus == '20'"
              >
                接收
              </div>
              <div
                @click="getDetail(slot.scope.row)"
                class="btn-box"
                v-if="slot.scope.row.invoiceStatus == '21'"
              >
                寄送
              </div>
              <!-- 开通百旺云-->
              <div
                      v-if=""
                      @click="checkDetail(slot.scope.row)"
                      class="btn-box"
                      v-if="slot.scope.row.invoiceStatus == '24' && isBWY"
              >
                开票信息提交
              </div>
              <!-- 未开通百旺云-->
              <div class="btn-box" v-if="slot.scope.row.invoiceStatus == '24' && !isBWY"
                   @click="toConfirm(slot.scope.row)">
                开票确认
              </div>
              <div @click="checkDetail(slot.scope.row)" class="btn-box">
                查看详情
              </div>
            </div>
          </template>
        </table-list>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="productTagPage.currentPage"
            :page-size="productTagPage.pageSize"
            :total="productTagPage.pageTotal"
            prev-text="上一页"
            next-text="下一页"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <e-dialog
      :dialogTitle="dialogTitle"
      :centerDialogVisible="visible"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
    >
      <p v-if="electronicInvoiceFlag === 1" >
        接收开票申请代表您已知晓采购商的开票需求，后续请尽快完成发票开具，是否确认接收
      </p>
      <p v-else>
        接收开票申请代表您已知晓采购商的开票需求，后续请尽快完成发票开具并寄送给采购商指定地址。是否确认接收
      </p>
    </e-dialog>
    <e-dialog
      :dialogTitle="dialogTitle"
      :centerDialogVisible="sendVisible"
      @updateVisible="updateVisible"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      :popupWidth="'800px'"
    >
      <el-form ref="form" :model="form" label-width="130px">
        <el-form-item label="发票寄送地址：">
          {{ address }}
        </el-form-item>
        <el-form-item label="请选择寄送方式：" label-width="130px">
          <el-radio v-model="sendType" :label="1">随货寄送</el-radio>
          <el-radio v-model="sendType" :label="2">第三方配送</el-radio>
        </el-form-item>
        <div v-if="sendType == 1">
          <el-form-item label="发货单名称：" class="deliver-name">
            <el-input v-model="form.orderShipmentName"></el-input>
          </el-form-item>
          <el-form-item label="发货时间：" class="deliverTime">
            <el-date-picker
              v-model="form.deliveryTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-row style="margin-top: 10px">
            <el-button @click="resetSend">重置</el-button>
            <el-button type="primary" plain @click="listOrderReceiveName"
              >查询</el-button
            >
          </el-row>
          <table-list
            class="height"
            :loading="loading"
            :selectionShow="true"
            :table-data="sendData"
            :table-label="sendLabel"
            @handleButton="handleButton"
            :singleChoose="singleChoose"
            @handleSelectionChange="handleSelectionChange"
            style="margin-top: 10px"
            row-key="orderReceiveId"
          ></table-list>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="form.pageNum"
              :page-size="form.pageSize"
              :total="form.pageTotal"
              prev-text="上一页"
              next-text="下一页"
            >
            </el-pagination>
          </div>
        </div>
        <div v-if="sendType == 2" class="choose">
          <el-form-item label="请填写物流单号: ">
            <div class="logistics-no">
              <el-input
                v-model="sendSubmitData.logisticsCode"
                placeholder="请填写物流单号"
                @blur="selectExpressCompanyByBillNo"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="请选择物流公司：">
            <el-select
              v-model="sendSubmitData.carrierName"
              placeholder="请选择物流公司"
            >
              <el-option
                v-for="item in expressCompary"
                :key="item.shipperCode"
                :label="item.shipperName"
                :value="item.shipperCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </e-dialog>
  </div>
</template>
<script>
import eDialog from '@/components/common/epecDialog';
import eSearch from '../../components/common/e-search';
import tableList from '../../components/common/e-table-list';
import api from '../../api/order';
import userApi from '../../api/user';
import { mapState } from 'vuex';
export default {
  name: 'invocieManage',
  data() {
    return {
      isBWY: false,
      showFlag: false,
      expressCompary: [],
      address: '',
      sendType: 1,
      logisticsNo: '',
      indexShow: true,
      loading: false,
      singleChoose: true,
      dialogTitle: '开票申请接收',
      visible: false,
      sendVisible: false,
      tableData: [],
      orderInvoiceListId: '',
      electronicInvoiceFlag:'',
      purchaseCompanyId: '',
      tableLabel: [
        // { label: '序号', param: 'email', align: 'center', },
        // { label: '开票金额', param: 'totalAmount', align: 'center' },
        { label: '采购商名称', param: 'purchaseCompany', align: 'center' },
        {
          label: '开票状态',
          param: 'invoiceStatusDesc',
          align: 'center',
          width: '180',
        },
        {
          label: '开票形式',
          param: 'electronicInvoiceFlag',
          align: 'center',
          width: '180',
          slot: 'electronicInvoiceFlagSlot',
        },
        {
          label: '申请开票时间',
          param: 'createTime',
          align: 'center',
          width: '180',
        },
        {
          label: '操作',
          param: 'operation',
          align: 'center',
          slot: 'operate',
          width: '180',
        },
      ],
      sendLabel: [
        // { label: '订单号', param: 'email', align: 'center', },
        { label: '发货单名称', param: 'orderShipmentName', align: 'center' },
        {
          label: '发货时间',
          param: 'deliveryTime',
          align: 'center',
          width: '100px',
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      filterInfo: {
        data: {
          orderNo: null,
          purchaseCompany: null,
          count: 0,
          invoiceStatus: null,
          electronicInvoiceFlag: null,
          createTime: null,
          pageNum: 1,
          pageSize: 10,
        },
        fieldList: [
          { label: '订单编号', type: 'input', value: 'orderNo' },
          { label: '采购商名称', type: 'input', value: 'purchaseCompany' },
          {
            label: '开票状态',
            type: 'select',
            value: 'invoiceStatus',
            list: 'statusList',
          },
          {
            label: '开票形式',
            type: 'select',
            value: 'electronicInvoiceFlag',
            list: 'electronicInvoiceFlagList',
          },
          {
            label: '申请开票时间',
            type: 'date',
            value: 'createTime',
            dateType: 'datetimerange',
          },
        ],
        count: 100,
        /**配置项 */
        btnStyle: [
          { icon: 'el-icon-search', text: '过滤', type: 'primary' },
          { icon: 'el-icon-refresh', text: '重置' },
        ],
      },
      listTypeInfo: {
        statusList: [
          { id: null, name: '全部' },
          { id: 20, name: '待接收' },
          { id: 21, name: '待寄送' },
          { id: 22, name: '完成开票' },
          { id: 23, name: '已撤销' },
          { id: 24, name: '待开票' },
          { id: 25, name: '开票中' },
        ],
        electronicInvoiceFlagList: [
          { id: null, name: '全部' },
          { id: 0, name: '纸质发票' },
          { id: 1, name: '电子发票' },
        ],
        typeList: [
          { id: 1, name: '全部' },
          { id: 2, name: '商品批量新增' },
          { id: 3, name: '商品批量修改' },
          { id: 4, name: '协议价批量调价' },
        ],
      },
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      sendData: [],
      sendSubmitData: {
        orderReceiveId: '',
        orderShipmentName: '',
        carrierName: '', //物流公司名称
        logisticsCode: '',
      },
    };
  },
  computed: { ...mapState(['USERINFO']) },
  components: {
    eSearch,
    tableList,
    eDialog,
  },
  methods: {
    queryList() {
      api.page(this.filterInfo.data).then((res) => {
        if (res.code == '200' && res.data) {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;

          this.listInfoAndSwitch();
        } else {
          this.tableData = [];
          this.productTagPage.pageTotal = 0;
        }
      });
    },
    //判断供应商是否开通百旺云电子发票
    async listInfoAndSwitch() {
      const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
      const res = await userApi.listInfoAndSwitch({companyIds: [userInfo.companyId]});
      if (res.code === '200' && res.data.length > 0) {
        const {platformStatus, switchStatus} = res.data[0];
        if (platformStatus === 1 && switchStatus === 121) {
          this.isBWY = true;
        }
      }
    },
    dataFormate(time) {
      let arr = (
        time.getFullYear() +
        '-' +
        (time.getMonth() + 1) +
        '-' +
        time.getDate()
      ).split('-');
      if (arr[1].length == 1) {
        arr[1] = '0' + arr[1];
      }
      if (arr[2].length == 1) {
        arr[2] = '0' + arr[2];
      }
      return arr[0] + '-' + arr[1] + '-' + arr[2];
    },
    handleFilter(val) {
      if (val.createTime) {
        val.startTime = this.dataFormate(val.createTime[0]);
        val.endTime = this.dataFormate(val.createTime[1]);
      } else {
        val.startTime = null;
        val.endTime = null;
      }
      this.productTagPage.currentPage = 1;
       this.filterInfo.data = val;
      this.filterInfo.data.pageNum = 1;
       this.queryList();
    },
    //寄送重置
    resetSend() {
      this.form = {
        invoiceListId: this.form.invoiceListId,
        purchaseCompanyId: this.form.purchaseCompanyId,
        pageNum: 1,
        pageSize: 10,
      };
    },
    querySelect() {},
    //重置
    handleReset() {
      this.filterInfo.data = {
        orderNo: null,
        purchaseCompany: null,
        count: 0,
        invoiceStatus: null,
        electronicInvoiceFlag: null,
        createTime: null,
        pageNum: 1,
        pageSize: 10,
      };
      this.productTagPage.currentPage = 1;
       this.queryList();
    },
    handleButton() {},
    handleSortChange() {},
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.sendSubmitData.orderShipmentName =
          val[val.length - 1].orderShipmentName;
        this.sendSubmitData.orderReceiveId = val[val.length - 1].orderReceiveId;
      }
    },
    toConfirm(row) {
      this.$router.push({
        path: '/invoiceDetail',
        query: {
          orderInvoiceListId: row.orderInvoiceListId,
          purchaseCompanyId: row.purchaseCompanyId,
          showFlag: 'receive',
        },
      })
    },
    submitPopupData() {
      if (this.sendVisible) {
        //寄送
        api
          .sendInvoice({
            purchaseCompanyId: this.form.purchaseCompanyId,
            orderInvoiceListId: this.orderInvoiceListId,
            sendType: this.sendType,
            ...this.sendSubmitData,
          })
          .then((res) => {
            if (res.code == '200') {
              this.$message.success('寄送成功。');
              this.queryList();
            }
          });
      }
      if (this.visible) {
        //接收
        api.receiveInvoice({
          orderInvoiceListId: this.orderInvoiceListId,
          purchaseCompanyId: this.purchaseCompanyId,
        })
                .then((res) => {
                  if (res.code == '200') {
                    this.$message.success('接收成功。');
                    this.queryList();

                    if (this.electronicInvoiceFlag === 1) {
                      this.$router.push({
                        path: '/invoiceDetail',
                        query: {
                          orderInvoiceListId: this.orderInvoiceListId,
                          purchaseCompanyId: this.purchaseCompanyId,
                          showFlag: 'receive',
                        },
                      })
                    }
                  }
                });
      }
      this.sendVisible = false;
      this.visible = false;
    },
    resetPopupData() {
      this.sendVisible = false;
      this.visible = false;
    },

    handleSizeChange(val) {
      this.filterInfo.data.pageSize = val;
      this.filterInfo.data.pageNum = 1;
      this.productTagPage.pageSize = val;
      this.queryList();
    },
    handleCurrentChange(val) {
      this.filterInfo.data.pageNum = val;
      this.productTagPage.currentPage = val;
      this.queryList();
    },
    handleImportOrder() {},
    updateVisible(val) {
      if (this.sendVisible) {
        //清空数据
      }
      this.visible = val;
      this.sendVisible = val;
    },
    async handleRecive(data) {
      this.electronicInvoiceFlag = Number(data.electronicInvoiceFlag);
      //判断  入参 当前 供应商id  西域震坤行 限制   true 集成不显示，false 显示
      await api
        .companyWhetherSystemIntegrationByCompanyId({
          companyId: this.USERINFO.companyId,
          createTime: data.createTime,
        })
        .then((res) => {
          if (res.code == '200') {
            this.showFlag = res.data;
          }
        });
      if (this.showFlag) {
         this.$message.warning(
          '您好，该供应商已做集成对接，请在贵方平台进行操作。'
        );
        return false;
      }

      this.orderInvoiceListId = data.orderInvoiceListId;
      this.purchaseCompanyId = data.purchaseCompanyId;
      this.visible = true;
      this.dialogTitle = '开票申请接收';
    },
    checkDetail(data) {
      if (data.electronicInvoiceFlag === 1) {
        this.$router.push({
          path: '/electronicInvoice/invoiceForm',
          query: {
            orderInvoiceListId: data.orderInvoiceListId,
            purchaseCompanyId: data.purchaseCompanyId,
          },
        });
      } else {
        this.$router.push({
          path: '/invoiceDetail',
          query: {
            orderInvoiceListId: data.orderInvoiceListId,
            purchaseCompanyId: data.purchaseCompanyId,
          },
        });
      }
    },
    //开票信息提交
    handleEInvoice() {
      this.$router.push({
        path: '/electronicInvoice/invoiceForm',
        query: {
          orderInvoiceListId: data.orderInvoiceListId,
          purchaseCompanyId: data.purchaseCompanyId,
        },
      });
    },
    getDetail(data) {
      this.sendVisible = true;
      this.dialogTitle = '发票寄送';
      api
        .detail({
          orderInvoiceListId: data.orderInvoiceListId,
          purchaseCompanyId: data.purchaseCompanyId,
        })
        .then((res) => {
          if (res.code == '200') {
            this.address = res.data.address;
            this.form.invoiceListId = data.orderInvoiceListId;
            this.orderInvoiceListId = data.orderInvoiceListId;
            this.form.purchaseCompanyId = data.purchaseCompanyId;
            this.listOrderReceiveName();
          } else {
            this.$message.error('获取地址失败');
          }
        });
    },
    selectExpressCompanyByBillNo() {
      api
        .selectExpressCompanyByBillNo({
          billNo: this.sendSubmitData.logisticsCode,
        })
        .then((res) => {
          this.expressCompary = res.data;
        });
    },
    listOrderReceiveName() {
      if (this.form.deliveryTime) {
        this.form.startTime = this.form.deliveryTime[0];
        this.form.endTime = this.form.deliveryTime[1];
      }
      api.listOrderReceiveName(this.form).then((resData) => {
        if (resData.code == '200') {
          this.sendData = resData.data.records;
          this.form.pageTotal = resData.data.total;
        } else {
          this.$message.error(resData.message);
        }
      });
    },
  },
  mounted() {
    this.queryList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin-bottom: 10px;
  .sku-img {
    width: 70px;
    height: 70px;
  }
}
.line {
  display: flex;
  justify-content: space-around;
  div {
    cursor: pointer;
  }
}
.btn-box {
  color: #126edf;
  cursor: pointer;
  :hover {
    color: #0064c8;
  }
}
.pagination {
  display: flex;
  justify-content: flex-end;
}
//::v-deep .el-input{
//  width: 140px;
//}
.choose {
  ::v-deep .el-input__inner {
    width: 216px;
  }
  //::v-deep .el-input__suffix{
  //  right: -74px;
  //}
}
.deliver-name {
  ::v-deep .el-input--small .el-input__inner {
    width: 216px;
  }
}
.deliverTime {
  ::v-deep .el-date-editor .el-range__close-icon {
    width: 15px;
  }
  ::v-deep .el-range-editor--small .el-range-separator {
    width: 20px;
  }
  ::v-deep .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-date-editor--timerange.el-input__inner {
    width: 216px;
  }
}
</style>
